import React from 'react';
import { withTranslation, WithTranslation } from 'react-i18next';
import styled from 'styled-components/macro';
import BasicInfo from './BasicInfo';
import Consents from './Consents';
import { Customer } from '../../types';
import { Tabs } from '../../../components/Tabs';
import Overview from '../overview/containers/overview';
import Receipts from '../receipts/containers/receipts';
import Discounts from '../discounts/containers/discounts';
import Tokens from './Tokens';
import { CustomerToken } from '../../../types/customers';
import { Button } from '../../../components/Buttons';

interface Props extends WithTranslation {
    customer: Customer;
    tokens?: CustomerToken[];
    accountId: string;
    openDeleteCustomerModal: (accountId: string, customer_id: string) => void;
    openChangeCustomerIdModal: () => void;
}

const Details = ({ customer, tokens, t, accountId, openDeleteCustomerModal, openChangeCustomerIdModal }: Props) => {
    const [activeTab, setActiveTab] = React.useState('overview');
    return (
        <div>
            <Wrapper>
                <LeftColumn>
                    <BasicInfo customer={customer} accountId={accountId} />
                    <Consents customer={customer} accountId={accountId} />
                    <Tokens tokens={tokens} />
                    <br />
                    {!customer.deleted_at && (
                        <>
                            <Button
                                className="tiny red"
                                onClick={() => openDeleteCustomerModal(accountId, customer.id || '')}
                            >
                                {t('customers.customer.delete_customer.title')}
                            </Button>
                            <br />
                            <br />
                            <Button
                                className="tiny red"
                                onClick={() => openChangeCustomerIdModal()}
                            >
                                {t('customers.customer.change_customer_id.title')}
                            </Button>
                        </>
                    )}
                </LeftColumn>

                <RightColumn>
                    <Tabs
                        groups={[
                            {
                                id: 'overview',
                                option: t('customers.customer.tabs.overview'),
                                content: (
                                    <TabContentWrapper>
                                        <Overview />
                                    </TabContentWrapper>
                                ),
                            },
                            {
                                id: 'receipts',
                                option: t('customers.customer.tabs.receipts'),
                                content: (
                                    <TabContentWrapper>
                                        <Receipts />
                                    </TabContentWrapper>
                                ),
                            },
                            {
                                id: 'discounts',
                                option: t('customers.customer.tabs.discounts'),
                                content: (
                                    <TabContentWrapper>
                                        <Discounts />
                                    </TabContentWrapper>
                                ),
                            },
                        ]}
                        onTabClick={(id: string) => setActiveTab(id)}
                        active={activeTab}
                    />
                </RightColumn>
            </Wrapper>
        </div>
    );
};

export default withTranslation()(Details);

const Wrapper = styled.div`
    display: flex;
    flex-direction: row;
    margin: 0 auto;

    @media (max-width: 1200px) {
        flex-direction: column;
    }
`;

const LeftColumn = styled.div`
    background: #f5f7f8;
    max-width: 394px;
    flex: 0 0 auto;
    padding: 32px;
    font-size: 14px;

    @media (max-width: 1200px) {
        max-width: initial;
    }
`;

const RightColumn = styled.div`
    flex: 1 1 auto;
    margin-left: 22px;
    padding: 32px;

    @media (max-width: 1200px) {
        margin-left: 0;
        margin-top: 22px;
    }
`;

const TabContentWrapper = styled.div`
    margin: 30px 0;
`;
